import * as React from 'react';
import { IRoute } from 'lib/componentRouter';
import { ForgotPassword } from './model';
import { ForgotPasswordView } from './view';
import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';

export function ForgotPasswordRoute(model : ForgotPassword, appWrapper : AppWrapper) {
    return {
        view:
            <AppWrapperView model={appWrapper}>
                <ForgotPasswordView model={model} />
            </AppWrapperView>
    };
}


// WEBPACK FOOTER //
// ./apps/portcall/forgotpassword/route.tsx